import React from "react";
import classNames from "classnames";
import { Flex, ScreenSizeRender } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import styles from "./styles.scss";

interface PreviewBannerProps {
  children: React.ReactNode;
  onExit: () => void;
  exitButtonDataCy?: string;
  exitButtonText: string;
}

const PreviewBanner = ({
  children,
  exitButtonDataCy,
  exitButtonText,
  onExit,
}: PreviewBannerProps) => {
  return (
    <Flex
      className={styles.PreviewPortalBanner}
      justifyContent="center"
      alignSelf="center"
      alignItems="center"
    >
      {children}
      <span>
        <button
          type="button"
          className={classNames("btn", "btn-link")}
          data-cy={exitButtonDataCy}
          onClick={onExit}
        >
          <ScreenSizeRender large>{exitButtonText}</ScreenSizeRender>{" "}
          <Icon className={styles.PreviewPortalBannerReturnIcon} type="sign-in" />
        </button>
      </span>
    </Flex>
  );
};

export default PreviewBanner;
